/**
   * 把内存buffer转换为下载文件
   * @param {Buffer} buffer
   * @param {string} fileName
   * @param {string} fileName
   */
export function buffer2File(buffer, fileName, type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8') {
  const blob = new Blob([buffer], { type })
  const a = document.createElement('a')
  a.download = fileName
  a.href = URL.createObjectURL(blob)
  a.click()
  setTimeout(() => {
    URL.revokeObjectURL(a.href)
  }, 40000)
}

export async function getBase64Image(url) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const img = new Image()
    img.crossOrigin = 'Anonymous'
    img.addEventListener('load', () => {
      canvas.width = img.naturalWidth
      canvas.height = img.naturalHeight
      ctx.drawImage(img, 0, 0)
      resolve(canvas.toDataURL('image/jpeg'))
      canvas.remove()
      img.remove()
    })
    img.addEventListener('error', () => reject(new Error('图片加载失败')))
    img.src = url
  })
}

export async function downloadOssImageByUrl(url, name) {
  const fileName = name || url.split('/').pop()
  const userAgent = navigator.userAgent.toLocaleLowerCase()
  const a = document.createElement('a')
  a.download = fileName
  if (userAgent.match(/tencenttraveler/) || userAgent.match(/qqbrowse/)) {
    a.href = `${url.replace('zhiyi-web.oss-cn-hangzhou.aliyuncs.com', 'zhiyi-web.zhiyitech.cn').replace('zhiyi-image.oss-cn-hangzhou.aliyuncs.com', 'zhiyi-image-cdn.zhiyitech.cn')}?response-content-type=application/octet-stream`
  } else {
    a.href = await getBase64Image(`${url}?${Date.now()}`)
  }
  a.click()
  URL.revokeObjectURL(a.href)
}

export function getImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = src
    image.onload = () => resolve(image)
    image.onerror = reject
  })
}
